export default __webpack_public_path__ + "static/media/lr.6af0f7ec.svg";